import { render } from "./DynamicCrudTabla.vue?vue&type=template&id=af0161f6&ts=true"
import script from "./DynamicCrudTabla.vue?vue&type=script&lang=ts"
export * from "./DynamicCrudTabla.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicCrudTabla.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af0161f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af0161f6', __exports__)) {
    api.reload('af0161f6', __exports__)
  }
  
  module.hot.accept("./DynamicCrudTabla.vue?vue&type=template&id=af0161f6&ts=true", () => {
    api.rerender('af0161f6', render)
  })

}


export default __exports__